// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-details-panel {
  position: fixed;
  right: 0;
  top: 0px;
  bottom: 0;
  width: 350px;
  background: white;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  z-index: 1000;
}
.item-details-panel .panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid var(--ion-color-medium);
  background-color: var(--ion-color-primary);
  color: white;
}
.item-details-panel .panel-header h3 {
  margin: 0;
  font-size: 1.2rem;
}
.item-details-panel .panel-header ion-icon {
  font-size: 1.8rem;
  cursor: pointer;
  transition: opacity 0.2s;
}
.item-details-panel .panel-header ion-icon:hover {
  opacity: 0.7;
}
.item-details-panel .panel-content {
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
}
.item-details-panel .panel-content .item-info {
  margin-bottom: 2rem;
}
.item-details-panel .panel-content .item-info .item-header {
  position: relative;
  margin-bottom: 1rem;
}
.item-details-panel .panel-content .item-info ion-thumbnail {
  width: 100%;
  height: 200px;
  margin-bottom: 0;
}
.item-details-panel .panel-content .item-info ion-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.item-details-panel .panel-content .item-info .drag-handle {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
  background: rgba(102, 126, 234, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: move;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  transition: all 0.3s;
  z-index: 10;
}
.item-details-panel .panel-content .item-info .drag-handle:hover {
  background: rgb(102, 126, 234);
  transform: scale(1.1);
}
.item-details-panel .panel-content .item-info .drag-handle ion-icon {
  font-size: 1.5rem;
  color: white;
}
.item-details-panel .panel-content .item-info .info-group {
  margin-bottom: 1rem;
}
.item-details-panel .panel-content .item-info .info-group label {
  display: block;
  font-weight: 600;
  color: var(--ion-color-medium-shade);
  margin-bottom: 0.25rem;
  font-size: 0.9rem;
}
.item-details-panel .panel-content .item-info .info-group p {
  margin: 0;
  font-size: 1rem;
  color: var(--ion-color-dark);
}
.item-details-panel .panel-content .item-info .info-group.mark-checkbox {
  padding: 0.75rem;
  background: rgba(102, 126, 234, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(102, 126, 234, 0.2);
}
.item-details-panel .panel-content .item-info .info-group.mark-checkbox ion-checkbox {
  margin: 0;
  --size: 24px;
  --checkbox-background-checked: #667eea;
}
.item-details-panel .panel-content .sections-list h4 {
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
  color: var(--ion-color-dark);
}
.item-details-panel .panel-content .sections-list ion-list ion-item {
  --padding-start: 0;
  --padding-end: 0;
}
.item-details-panel .panel-content .sections-list ion-list ion-item ion-label h3 {
  font-weight: 500;
  margin-bottom: 0.25rem;
}
.item-details-panel .panel-content .sections-list ion-list ion-item ion-label p {
  font-size: 0.9rem;
  color: var(--ion-color-medium-shade);
}
.item-details-panel .panel-content .sections-list .empty-state {
  text-align: center;
  padding: 2rem 1rem;
  color: var(--ion-color-medium-shade);
  font-style: italic;
}

@media (max-width: 768px) {
  .item-details-panel {
    width: 100%;
    max-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/pages/catalog-admin/catalog-manager/item-details/item-details.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,yCAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AACF;AACE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,gDAAA;EACA,0CAAA;EACA,YAAA;AACJ;AACI;EACE,SAAA;EACA,iBAAA;AACN;AAEI;EACE,iBAAA;EACA,eAAA;EACA,wBAAA;AAAN;AAEM;EACE,YAAA;AAAR;AAKE;EACE,OAAA;EACA,gBAAA;EACA,aAAA;AAHJ;AAKI;EACE,mBAAA;AAHN;AAKM;EACE,kBAAA;EACA,mBAAA;AAHR;AAMM;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AAJR;AAMQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAJV;AAQM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,wCAAA;EACA,oBAAA;EACA,WAAA;AANR;AAQQ;EACE,8BAAA;EACA,qBAAA;AANV;AASQ;EACE,iBAAA;EACA,YAAA;AAPV;AAWM;EACE,mBAAA;AATR;AAWQ;EACE,cAAA;EACA,gBAAA;EACA,oCAAA;EACA,sBAAA;EACA,iBAAA;AATV;AAYQ;EACE,SAAA;EACA,eAAA;EACA,4BAAA;AAVV;AAaQ;EACE,gBAAA;EACA,qCAAA;EACA,kBAAA;EACA,0CAAA;AAXV;AAaU;EACE,SAAA;EACA,YAAA;EACA,sCAAA;AAXZ;AAkBM;EACE,kBAAA;EACA,iBAAA;EACA,4BAAA;AAhBR;AAoBQ;EACE,kBAAA;EACA,gBAAA;AAlBV;AAqBY;EACE,gBAAA;EACA,sBAAA;AAnBd;AAsBY;EACE,iBAAA;EACA,oCAAA;AApBd;AA0BM;EACE,kBAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;AAxBR;;AA8BA;EACE;IACE,WAAA;IACA,eAAA;EA3BF;AACF","sourcesContent":[".item-details-panel {\n  position: fixed;\n  right: 0;\n  top: 0px;\n  bottom: 0;\n  width: 350px;\n  background: white;\n  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  z-index: 1000;\n\n  .panel-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem;\n    border-bottom: 1px solid var(--ion-color-medium);\n    background-color: var(--ion-color-primary);\n    color: white;\n\n    h3 {\n      margin: 0;\n      font-size: 1.2rem;\n    }\n\n    ion-icon {\n      font-size: 1.8rem;\n      cursor: pointer;\n      transition: opacity 0.2s;\n\n      &:hover {\n        opacity: 0.7;\n      }\n    }\n  }\n\n  .panel-content {\n    flex: 1;\n    overflow-y: auto;\n    padding: 1rem;\n\n    .item-info {\n      margin-bottom: 2rem;\n\n      .item-header {\n        position: relative;\n        margin-bottom: 1rem;\n      }\n\n      ion-thumbnail {\n        width: 100%;\n        height: 200px;\n        margin-bottom: 0;\n\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n        }\n      }\n\n      .drag-handle {\n        position: absolute;\n        top: 10px;\n        right: 10px;\n        width: 40px;\n        height: 40px;\n        background: rgba(102, 126, 234, 0.9);\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: move;\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n        transition: all 0.3s;\n        z-index: 10;\n\n        &:hover {\n          background: rgba(102, 126, 234, 1);\n          transform: scale(1.1);\n        }\n\n        ion-icon {\n          font-size: 1.5rem;\n          color: white;\n        }\n      }\n\n      .info-group {\n        margin-bottom: 1rem;\n\n        label {\n          display: block;\n          font-weight: 600;\n          color: var(--ion-color-medium-shade);\n          margin-bottom: 0.25rem;\n          font-size: 0.9rem;\n        }\n\n        p {\n          margin: 0;\n          font-size: 1rem;\n          color: var(--ion-color-dark);\n        }\n\n        &.mark-checkbox {\n          padding: 0.75rem;\n          background: rgba(102, 126, 234, 0.05);\n          border-radius: 8px;\n          border: 1px solid rgba(102, 126, 234, 0.2);\n\n          ion-checkbox {\n            margin: 0;\n            --size: 24px;\n            --checkbox-background-checked: #667eea;\n          }\n        }\n      }\n    }\n\n    .sections-list {\n      h4 {\n        margin: 0 0 1rem 0;\n        font-size: 1.1rem;\n        color: var(--ion-color-dark);\n      }\n\n      ion-list {\n        ion-item {\n          --padding-start: 0;\n          --padding-end: 0;\n\n          ion-label {\n            h3 {\n              font-weight: 500;\n              margin-bottom: 0.25rem;\n            }\n\n            p {\n              font-size: 0.9rem;\n              color: var(--ion-color-medium-shade);\n            }\n          }\n        }\n      }\n\n      .empty-state {\n        text-align: center;\n        padding: 2rem 1rem;\n        color: var(--ion-color-medium-shade);\n        font-style: italic;\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .item-details-panel {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
